import { Injectable } from '@angular/core';
import { Workbook } from 'exceljs/dist/exceljs.min.js';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  generateExcel(title: string, worksheets: WorksheetData[]) {
    const workbook = new Workbook();
    worksheets.forEach(w => {
      const worksheet = workbook.addWorksheet(w.worksheetTitle, { headerFooter: { firstHeader: w.worksheetTitle, differentFirst: true } });

      worksheet.mergeCells(1,1,1,w.worksheetHeaders.length);
      worksheet.getCell('A1').value = title;

      const headerRow = worksheet.addRow(w.worksheetHeaders);
      headerRow.eachCell((cell, number) => {
        cell.style = {
          font: {
            bold: true
          }
        };
      });

      w.WorksheetRows.forEach((row) => {
        worksheet.addRow(row);
      });
    });

    return workbook;

  }

  generateExcelReport(title: string, worksheets: WorksheetData[], filter: string) {
    const workbook = new Workbook();
    worksheets.forEach(w => {
      const worksheet = workbook.addWorksheet(w.worksheetTitle, { headerFooter: { firstHeader: w.worksheetTitle, differentFirst: true } });

      worksheet.mergeCells(1,1,1,w.worksheetHeaders.length);
      worksheet.getCell('A1').value = title;

      // if(filter != null && filter != '')
      //   worksheet.addRow(filter);

      // filter.forEach((x, i) => {
      //   worksheet.mergeCells(i+2,1,i+2,w.worksheetHeaders.length);
      //   worksheet.getCell('A'+(i+2)).value = x;
      // });

      if(filter != null && filter != ''){
        worksheet.mergeCells(2,1,2,w.worksheetHeaders.length);
        worksheet.getCell('A2').value = filter;
      }

      const headerRow = worksheet.addRow(w.worksheetHeaders);
      headerRow.eachCell((cell, number) => {
        cell.style = {
          font: {
            bold: true
          }
        };
      });

      w.WorksheetRows.forEach((row) => {
        worksheet.addRow(row);
      });

      worksheet.columns.forEach(col => {
        col.eachCell(cell => {          
          if (+cell.value){
            cell.value = +cell.value;
          } else if(cell.value?.slice(0,2) == 'R$'){
            cell.value = +cell.value.replace('R$', '').replace(/\./g, '').replace(/,/g, '.')
            cell.numFmt = 'R$ #,##0.00';      
          }
        })
      })
    });

    return workbook;
  }
}

export class WorksheetData {
  worksheetTitle: string;
  worksheetHeaders: Array<string>;
  WorksheetRows: Array<Array<string>>;
}
